import { Field, FieldError, FieldLabel } from "@/client/components/shad/field";
import { Input } from "@/client/components/shad/input";
import { useFieldContext } from "../form-context";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSlot,
} from "@/client/components/shad/input-otp";

import { REGEXP_ONLY_DIGITS } from "input-otp";

export function OTPField({ label }: { label: string }) {
  const field = useFieldContext<string>();
  const isInvalid = field.state.meta.isTouched && !field.state.meta.isValid;
  return (
    <Field className="w-fit">
      <FieldLabel htmlFor="opt-digits-only">{label}</FieldLabel>

      <InputOTP
        name={field.name}
        value={field.state.value}
        onChange={field.handleChange}
        id="opt-digits-only"
        maxLength={6}
        pattern={REGEXP_ONLY_DIGITS}
      >
        <InputOTPGroup className="*:data-[slot=input-otp-slot]:h-10 *:data-[slot=input-otp-slot]:w-11 *:data-[slot=input-otp-slot]:text-base">
          <InputOTPSlot index={0} aria-invalid={isInvalid} />
          <InputOTPSlot index={1} aria-invalid={isInvalid} />
          <InputOTPSlot index={2} aria-invalid={isInvalid} />
          <InputOTPSlot index={3} aria-invalid={isInvalid} />
          <InputOTPSlot index={4} aria-invalid={isInvalid} />
          <InputOTPSlot index={5} aria-invalid={isInvalid} />
        </InputOTPGroup>
      </InputOTP>
      {isInvalid && (
        <FieldError className="text-xs" errors={field.state.meta.errors} />
      )}
    </Field>
  );
}
